import { render, staticRenderFns } from "./ArticleStatistics.vue?vue&type=template&id=f6a82be8&"
import script from "./ArticleStatistics.vue?vue&type=script&lang=js&"
export * from "./ArticleStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports